var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8953_5724)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#223BF4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 13,
    fill: "#EEF0FE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.8708,
    cy: 15.8708,
    r: 6.6709,
    fill: "#223BF4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.2854,
    cy: 15.2855,
    r: 0.980613,
    transform: "rotate(22.9644 11.2854 15.2855)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.8792,
    cy: 15.7061,
    r: 0.980613,
    transform: "rotate(22.9644 19.8792 15.7061)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6357 16.5239C15.3505 17.2826 16.2694 17.2162 16.7802 16.6456",
    stroke: "white",
    strokeWidth: 0.525241,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 32C28 28.8174 26.7357 25.7652 24.4853 23.5147C22.2348 21.2643 19.1826 20 16 20C12.8174 20 9.76516 21.2643 7.51472 23.5147C5.26428 25.7652 4 28.8174 4 32L16 32H28Z",
    fill: "#223BF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8953_5724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholder);
export default __webpack_public_path__ + "static/media/avatar-placeholder.66cb11cc8f5b7ca6ca35ea7f79ca6854.svg";
export { ForwardRef as ReactComponent };